import {
  Component,
  ElementRef,
  EventEmitter,
  OnInit,
  Output,
  Renderer2,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatMenuTrigger, MatTooltip } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { config } from '../../../../../config/config';
import {
  CustomDefaultPlaceCategory,
  VisitorCalendarActionCommand,
} from '../../../../commands/pagination.query.command';
import { AllFrontendSettingsCommand } from '../../../../commands/visitor/all.frontend.settings.command';
import { CreateTripCommand, TripStorageCommand } from '../../../../commands/visitor/create.trip.command';
import { ButtonTriggerEvent } from '../../../../common/components';
import { BaseComponent } from '../../../../common/components/base.component';
import { ConfirmModalComponent } from '../../../../common/components/confirm.modal/confirm.modal.component';
import {
  ConfirmModalActions,
  ConfirmModalData,
} from '../../../../common/components/confirm.modal/confirm.modal.provider';
import { CreateTripModalComponent } from '../../../../common/components/create.trip.modal/create.trip.modal.component';
import { CreateTripModalActions } from '../../../../common/components/create.trip.modal/create.trip.modal.provider';
import {
  MobileIFrameExportPdfAlertModal
} from '../../../../common/components/mobile.iframe.export.pdf.alert.modal/mobile.iframe.export.pdf.alert.modal';
import {
  MobileIFrameExportPdfAlertModalData
} from '../../../../common/components/mobile.iframe.export.pdf.alert.modal/mobile.iframe.export.pdf.alert.modal.provider';
import {
  SocialLoginPopupComponent
} from '../../../../common/components/social.login.popup/social.login.popup.component';
import { HubVisitorDataSource } from '../../../../models/hub/hub.visitor.data.source';
import { HubVisitorFeatureToggle } from '../../../../models/hub/hub.visitor.feature.toggle';
import { PlaceService } from '../../../../services/place.service';
import { LogoCommand, PDFSettingCommand } from '../../../hub/export.pdf.modal/export.pdf.modal.provider';
import { bindFunctionsToThis, clone, isNullOrUndefined } from '../../../../common/extensions';
import { GoogleMapsService } from '../../../../common/services/google.maps.service';
import { ModalService } from '../../../../common/services/modal.service';
import { HubEvent } from '../../../../models/hub/hub.event';
import { HubPlace } from '../../../../models/hub/hub.place';
import { HubTour } from '../../../../models/hub/hub.tour';
import { CustomizationApiService } from '../../../../services/customization.api.service';
import { EventTimeService } from '../../../../services/event.time.service';
import { ExportService, PDFType } from '../../../../services/export.csv.service';
import { ImageService } from '../../../../services/image.service';
import { LocalStorageService } from '../../../../services/localStorageService';
import { VisitorApiService } from '../../../../services/visitor.api.service';
import {
  AllFrontendSettingsStore,
  VisitorDataCache,
  VisitorTripNotifyAddOrRemoveItemStore,
  VisitorTripStore,
} from '../../../../stores/visitor.calendar.store';
import { guid } from '../../../../utils/guid';
import { AttractionListComponent } from '../../../hub/tours/attractions/attraction.list.component';
import { EventDetailsModalComponent } from '../../event.details.modal/event.details.modal.component';
import { EventDetailsModalActions } from '../../event.details.modal/event.details.modal.provider';
import { PlaceDetailsModalComponent } from '../../place.details.modal/place.details.modal.component';
import { PlaceDetailsModalActions } from '../../place.details.modal/place.details.modal.provider';
import { ShareTripModalComponent } from '../share.trip.modal/share.trip.modal.component';
import { ShareTripModalActions, ShareTripModalData } from '../share.trip.modal/share.trip.modal.provider';
import { TripDetailModalComponent } from '../trip.detail.modal/trip.detail.modal.component';
import { TripDetailModalActions, TripDetailModalData } from '../trip.detail.modal/trip.detail.modal.provider';
import { TripFloatDetailComponent } from '../trip.float.detail/trip.float.detail.component';
import { VisitorTripComponent } from '../visitor.trip.component';
import { StyleModel } from '../../../../commands/hub/style.command';
import { getRouteUrl, routeConfigs } from '../../../../common/constants/route.config';
import { PlaceType } from '../../../hub/place.category/customize.place.category.component';
import {
  CustomDefaultPlaceCategoryAccordionComponent
} from '../../../hub/custom.default.place.category.accordion/custom.default.place.category.accordion.component.';

@Component({
  selector: 'ig-visitor-trip-side-bar',
  templateUrl: './visitor.trip.side.bar.component.html',
  styleUrls: ['./visitor.trip.side.bar.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class VisitorTripSideBarComponent extends BaseComponent implements OnInit {
  public pdfSettings = new PDFSettingCommand();
  public events: HubEvent[];
  public places: HubPlace[];
  public placeRows: any[];
  public eventRows: any[];
  public tours: HubTour[];
  public currentTour: HubTour;
  public currentTrip: any;
  public currentTripIndex = -1;
  public trips: any;
  public defaultTripName = 'Day ';
  public maxTripCount = config.tripPlanner.maxTripCount;
  public tripCount = 0;
  public displayingOn = 'feed';
  public category = {
    event: 'All',
    place: 'Dining & Nightlife',
  };
  public defaultPlaceCategory = 'Dining & Nightlife';
  public isLoadingAllPlaces = false;
  public isPlanStarted = false;
  public isSwitching = false;
  public isOpeningTrip = false;
  public isPlaceStartPageShown = false;
  public isShowFilter = false;
  public isEditTripModes = [];
  public isEditTripMode = false;
  public isShortPlaceDescription = false;
  public placeCategoryCount = 0;
  public filter = {
    isInitialStatus: true,
    eventAll: true,
    event: {
      art: {key: 'Arts', value: true},
      meeting: {key: 'Conferences & Meetups', value: true},
      classes: {key: 'Classes & Workshops', value: true},
      entertainment: {key: 'Entertainment', value: true},
      festival: {key: 'Festivals', value: true},
      food: {key: 'Food & Drinks', value: true},
      neighborhood: {key: 'Neighborhood', value: true},
      shopping: {key: 'Shopping', value: true},
      sport: {key: 'Outdoors & Fitness', value: true},
      other: {key: 'Other', value: true},
    },
    placeAll: true,
    place: {
      dining: {key: 'Dining & Nightlife', short: 'Dine', value: true},
      accommodation: {key: 'Accommodations', short: 'Stay', value: false},
      art: {key: 'Arts & Culture', short: 'Arts', value: false},
      shopping: {key: 'Shopping', short: 'Shop', value: false},
      activity: {key: 'Activities', short: 'Activities', value: false},
      outdoor: {key: 'Outdoors', short: 'Outdoors', value: false},
      wellness: {key: 'Wellness', short: 'Wellness', value: true},
      entertainment: {key: 'Entertainment', short: 'Entertainment', value: false},
      travel: {key: 'Transportation', short: 'Travel', value: false},
      other: {key: 'Other', short: 'Other', value: false},
      thingsToDo: {key: 'ThingsToDo', short: 'things to do', value: false},

      beauty: {key: 'Beauty', short: 'Beauty', value: false},
      car: {key: 'Cars & Motor Services', short: 'Cars', value: false},
      cleaning: {key: 'Cleaning Services', short: 'Cleaning', value: false},
      pet: {key: 'Pet Services', short: 'Pets', value: false},
      drug: {key: 'Convenience & Pharmacies', short: 'Pharmacies', value: false},
      otherTypes: {key: 'Other Types', short: 'Other types', value: false},
    },
  };

  public fromForMobile: Date;
  public toForMobile: Date;
  public today = new Date();
  public tourSideImg = config.tripPlannerTourSideImg;
  public tripImages = [config.defaultImageUrl]; //config.tripPlanner.tripImages;
  public tripImageIndex = 0;
  public placeCategoryStartImg = config.tripPlanner.placeCategoryStartPage;
  public hubName: string;
  public userFacebookID: string;
  public actionCommand = new VisitorCalendarActionCommand();
  public showingCount: string;
  public paginationIndex = 0;
  public paginationPageLimit = 10;
  public paginationPageLimitForEvents = this.isMobile ? 10 : 32;
  public paginationPageLimitForPlacesOnDesktop = 32;
  public cardCountInRow = 4;
  public cardCountInRowForMobileEvent = 1;
  public cardCountInRowForMobilePlace = 2;
  public isPaginationInitStatus = true;
  public isDownloadingPDF = false;
  public isSearch = false;
  public noMoreNext = false;
  public noMoreBack = true;
  public latLngBounds: any;
  public tripFormGroup: FormGroup;
  public allEventsOrPlaces: HubEvent[] | HubPlace[];
  public filterDateRangeText = '';
  public logo: LogoCommand;
  public detailsStyle = 'popup';
  public logoUrl = '';
  public placeCategoryHeight = '38px';
  public placeCategoryHeightMobile = '38px';
  public cardContainerPlaceHeight = '489px';
  public cardContainerPlaceFullHeight = 'none'; //'356px';
  public cardContainerMaxHeight = '548px';
  public cardContainerMaxHeightForTrip = '507px';
  public cardContainerFullHeight = '548px';
  public cardContainerFullHeightForNoPagging = '500px';
  public tourSpinner = [];
  public featuresToggle = new HubVisitorFeatureToggle();
  public dataSource = new HubVisitorDataSource();
  public customDefaultPlaceCategory: CustomDefaultPlaceCategory;
  public analytics = new HubAnalytics();
  public style = new StyleModel();
  @ViewChild('filterEle') private filterElement: ElementRef;
  @ViewChild('cardwrap') private cardWrap: ElementRef;
  @ViewChild('count') private countIcon: ElementRef;
  @ViewChild('countbase') public countBaseIcon: ElementRef;
  @ViewChild('cardcontainer') private cardContainer: ElementRef;
  @ViewChild('tripCategoryWrap') private tripCategoryWrap: ElementRef;
  @ViewChild('print') private print: ElementRef;
  @ViewChild('placeAll') private placeAll: ElementRef;
  @ViewChild('placeStay') private accommodation: ElementRef;
  @ViewChild('placeDining') private dining: ElementRef;
  @ViewChild('placeShopping') private shopping: ElementRef;
  @ViewChild('placeActivity') private activity: ElementRef;
  @ViewChild('placeOutdoor') private outdoor: ElementRef;
  @ViewChild('placeEntertainment') private entertainment: ElementRef;
  @ViewChild('placeTransportation') private transportation: ElementRef;
  @ViewChild('placeOther') private other: ElementRef;
  @ViewChild('details') detailsPanel: TripFloatDetailComponent;
  @ViewChild('routemaptrigger') mobileMapTrigger: ElementRef;
  @ViewChild('tripTitleInput') tripTitleInput: any;
  @ViewChild('placeMask') placeMask: ElementRef;
  @ViewChild('placeCategoryMask') placeCategoryMask: ElementRef;
  @ViewChild('placeCategoryStartPage') placeCategoryStartPage: ElementRef;
  @ViewChild('placeCategoryCloseIcon') placeCategoryCloseIcon: ElementRef;
  @ViewChild('placeStayStartPageIcon') placeStayStartPageIcon: ElementRef;
  @ViewChild('startPageIconWrap') startPageIconWrap: ElementRef;
  @ViewChild('placeCategoryStartPageTooltip') placeCategoryStartPageTooltip: MatTooltip;
  @ViewChild('attractionlist') public attractionlist: AttractionListComponent;
  @ViewChild('menuTrigger') public menuTrigger: MatMenuTrigger;
  @ViewChild('customDefaultPlaceAccordion')
  public customDefaultPlaceAccordion: CustomDefaultPlaceCategoryAccordionComponent;
  @Output() openMap: EventEmitter<any> = new EventEmitter();
  @Output() hideMap: EventEmitter<any> = new EventEmitter();
  @Output() onMapReady: EventEmitter<any> = new EventEmitter();
  @Output() tripListReordered: EventEmitter<any> = new EventEmitter();
  @Output() showInfoWindowOnMap = new EventEmitter<any>();
  @Output() removeFromTripEvent = new EventEmitter<any>();
  @Output() showTourWaterfall = new EventEmitter<any>();
  @Output() onFloatDetailShown = new EventEmitter<any>();
  @Output() onFloatDetailClosed = new EventEmitter<any>();
  @Output() onFloatDetailFeedsClosed = new EventEmitter<any>();
  @Output() onFloatDetailPlaceFeedsRetrieved = new EventEmitter<any>();

  constructor(
    private router: Router,
    public imageService: ImageService,
    public visitorApiService: VisitorApiService,
    private googleMapService: GoogleMapsService,
    private render: Renderer2,
    private exportService: ExportService,
    private visitorTripStore: VisitorTripStore,
    public parent: VisitorTripComponent,
    private modalService: ModalService,
    private allFrontendSettingsStore: AllFrontendSettingsStore,
    private notifyAddOrRemoveItemStore: VisitorTripNotifyAddOrRemoveItemStore,
    private customizationApiService: CustomizationApiService,
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute
  ) {
    super({activatedRoute});
    bindFunctionsToThis(this);
  }

  public ngOnInit() {
    let {hubName} = this.allRouteParams;
    this.hubName = hubName;
    this.placeCategoryStartImg = this.imageService.imageSourceUrl(this.placeCategoryStartImg);

    this.tripFormGroup = this.formBuilder.group({
      tripTitle: [null],
    });

    this.isShortPlaceDescription = window.innerWidth < 365;
    this.events = [];
    this.places = [];

    setTimeout(() => {
      this.setFacebookUserID();
    });

    this.listenShowOnMap();
    this.takeSettingsAndProcess();
  }

  public get displayingOnColor() {
    const key = ['event', 'place', 'tour', 'trip'].indexOf(this.displayingOn) < 0 ? 'event' : this.displayingOn;
    return this.style.tripPlanner[key].color.value;
  }

  public get isShowThingsToDo() {
    return (
      this.featuresToggle.placeCategory.activity ||
      this.featuresToggle.placeCategory.art ||
      this.featuresToggle.placeCategory.outdoor ||
      this.featuresToggle.placeCategory.entertainment
    );
  }

  public get isShowingEventOrPlace() {
    return this.displayingOn === 'event' || this.displayingOn === 'place';
  }

  private get isAllPlaceCategoriesTurnedOff() {
    return PlaceService.isAllCategoriesTurnedOff(this.featuresToggle.placeCategory);
  }

  public get listTitle() {
    if (this.displayingOn === 'tour') {
      if (this.parent.isForTourList && this.currentTour) {
        return 'Back to All Itineraries';
      }
      if (this.featuresToggle.multipleCities) {
        return this.parent.isForTourList ? 'All Itineraries' : 'Regional Itineraries';
      }
      return 'Itineraries';
    }
    if (this.displayingOn === 'trip') {
      return 'my trips';
    }
    return this.displayingOn + 's';
  }

  public get isEventEnabled() {
    return this.featuresToggle.manualEvents || this.featuresToggle.eventByGeolocation;
  }

  public get isPlaceEnabled() {
    return this.featuresToggle.placeCalendar;
  }

  public get isNoItem() {
    return (
      (this.displayingOn === 'event' && !this.events.length) ||
      (this.displayingOn === 'place' && !this.places.length) ||
      (this.displayingOn === 'tour' && !this.tours.length)
    );
  }

  public get isNoTrip() {
    return this.displayingOn === 'trip' && (!this.trips || !this.trips.length);
  }

  public FBLoggedIn() {
    this.setFacebookUserID();
  }

  public showRouteOnMapForMobile() {
    if (this.displayingOn === 'trip') {
      this.parent.showDirectionMap(this.currentTrip);
    } else if (this.displayingOn === 'tour') {
      this.parent.showDirectionMap(this.currentTour);
    }
  }

  public switchToEvents(isFirstTime = false) {
    if (!isFirstTime && this.displayingOn === 'event') {
      return;
    }
    this.parent.direction && this.parent.direction.isStarted && this.parent.direction.stopPlan();
    this.detailsPanel.closeDetails();
    this.parent.searchText = null;
    this.parent.isSearchDisabled = false;
    this.isSearch = false;
    this.cardWrap.nativeElement.style.overflowY = 'auto';
    this.paginationPageLimit = this.paginationPageLimitForEvents;
    //if (!this.category.event) {
    // this.displayingOn = 'event';
    //
    // this.toggleFilter(true);
    //     this.events = [];
    //     this.showingCount = null;
    //     this.cardWrap.nativeElement.style.maxHeight = '564px';
    //     if (this.isShowFilter) {
    //         this.filterElement.nativeElement.style.height = '280px';
    //     }
    //}
    this.isSwitching = true;
    this.getEventsFromCache().subscribe((data) => {
      this.afterGotEvents(data);
    });
  }

  public switchToPlaces(isShowSpinner = true, feedId = null, isGotoTours = false) {
    this.cardCountInRow = this.isMobile ? this.cardCountInRowForMobilePlace : this.cardCountInRow;
    this.parent.direction && this.parent.direction.isStarted && this.parent.direction.stopPlan();
    this.detailsPanel.closeDetails();
    this.parent.searchText = null;
    this.parent.isSearchDisabled = false;
    this.isSearch = false;
    this.parent.from = null;
    this.parent.to = null;
    this.parent.isStarted = true;
    if (!this.isMobile) {
      this.paginationPageLimit = this.paginationPageLimitForPlacesOnDesktop;
    } else {
      this.paginationPageLimit = this.paginationPageLimitForEvents;
    }
    if ((!this.customDefaultPlaceCategory || this.customDefaultPlaceCategory.useDefault) && !this.category.place) {
      this.places = [];
      this.placeRows = [];
      this.afterGotPlaces([]);
      return;
    }
    if (isShowSpinner) {
      this.isSwitching = true;
    }

    // if (!this.isPlaceStartPageShown) {
    //     if (!this.featuresToggle.multipleCities) {
    //         this.showPlaceCategoryStartPage();
    //     }
    // }

    if (!VisitorDataCache.placeCategories) {
      this.visitorApiService.getPlaceCategories().subscribe((data) => {
        VisitorDataCache.placeCategories = clone(data);
        this.procecssPlaces(feedId, isGotoTours);
      });
    } else {
      this.procecssPlaces(feedId, isGotoTours);
    }

    if (isGotoTours) {
      setTimeout(() => {
        this.switchToTours();
      });
    }
  }

  public switchToTours(tourId?: string) {
    this.parent.setPDFLoadingTip([3, 4, 5, 6]); // this is a fake PDF downloading progress
    this.parent.direction && this.parent.direction.isStarted && this.parent.direction.stopPlan();
    this.isSwitching = true;
    this.detailsPanel.closeDetails();
    this.parent.searchText = null;
    this.parent.isSearchDisabled = true;
    this.isSearch = false;
    this.parent.from = null;
    this.parent.to = null;
    this.parent.isStarted = true;
    //this.cardWrap.nativeElement.style.overflowY = 'hidden';
    this.cardWrap.nativeElement.style.overflowY = 'auto';

    if (!VisitorDataCache.tours || !VisitorDataCache.tours.length) {
      this.visitorApiService.getTours(this.hubName).subscribe((data) => {
        VisitorDataCache.tours = data;
        this.afterGotTours(data, tourId);
      });
    } else {
      this.afterGotTours(VisitorDataCache.tours, tourId);
    }
  }

  public async switchToTrip(isShared = false, tripIndex?: number) {
    // if (this.isMobile)
    // {
    //     //this.userFacebookID = '10214072230112487';
    //     this.displayingOn = 'trip';
    //     this.isOpeningTrip = true;
    //     try {
    //         this.setFacebookUserID();
    //         this.parent.syncTripsWithDBAsync(this.userFacebookID).subscribe(trips => {
    //             this.afterSetTrips(isShared, tripIndex);
    //             this.isOpeningTrip = false;
    //         });
    //     } catch (ex) {
    //         this.afterSetTrips(isShared, tripIndex);
    //         this.isOpeningTrip = false;
    //     }
    //
    //     return;
    // }
    this.parent.setPDFLoadingTip([3, 4, 5, 6]);
    this.setFacebookUserID();
    await this.loadUserTripFromDB();
    this.isSearch = false;
    this.afterSetTrips(isShared, tripIndex);
  }

  public async loadUserTripFromDB() {
    if (this.userFacebookID) {
      const userTrip = await this.visitorApiService.getUserTrips(this.hubName, this.userFacebookID).toPromise();
      const keyWithUserID = LocalStorageService.getLocalStorageKeyForVisitorTrip(this.hubName, this.userFacebookID);
      const key = LocalStorageService.getLocalStorageKeyForVisitorTrip(this.hubName);
      localStorage.setItem(keyWithUserID, JSON.stringify(userTrip || ''));
      localStorage.setItem(key, JSON.stringify(userTrip || ''));

      this.getTripCount(this.userFacebookID);
    }
  }

  public filterEvents() {
    this.visitorApiService
      .getEvents(this.hubName, {
        limit: config.searchLimit,
        page: 1,
        category: 'all',
        from: this.fromForMobile,
        to: this.toForMobile,
      })
      .subscribe((data) => {
        this.setEventDateRange(this.fromForMobile, this.toForMobile);
        VisitorDataCache.events = data;
        this.afterGotEvents(data);
      });
  }

  public showTourDetail(tour) {
    if (tour) {
      this.currentTour = tour;

      if (!this.isMobile) {
        this.cardWrap.nativeElement.style.overflowY = 'auto';
        this.cardWrap.nativeElement.style.maxHeight = this.cardContainerMaxHeightForTrip; //'auto !important';
        this.cardContainer.nativeElement.style.maxHeight = 'auto'; //this.cardContainerMaxHeight;
        this.cardContainer.nativeElement.style.overflowY = 'auto';
      } else {
        this.cardWrap.nativeElement.style.overflowY = 'hidden';
        this.cardWrap.nativeElement.style.height = 'auto';
        this.cardContainer.nativeElement.style.overflowY = 'auto';
        this.scrollToTop();
      }
    }
  }

  public goToSubmitPage() {
    const path = getRouteUrl(routeConfigs.submit[this.displayingOn], {
      hubName: this.hubName,
    });
    console.log({path});
    this.router.navigateByUrl(path, {skipLocationChange: this.noChangeUrlWhenRedirect});
  }

  public pagingBack() {
    if (this.noMoreBack) {
      return;
    }

    this.paginationIndex--;
    let start = this.paginationPageLimit * this.paginationIndex;
    let end = start + this.paginationPageLimit;
    if (start <= 0) {
      start = 0;
      this.noMoreBack = true;
    }
    if (this.displayingOn === 'event') {
      this.events = <HubEvent[]>this.allEventsOrPlaces.slice(start, end);
      this.processMultiColumnsItems();
      this.events = this.setEventMapIcon(this.events || []);
      if (!this.isMobile) {
        this.parent.showOnMap({items: this.events, index: null});
      }
    } else if (this.displayingOn === 'place') {
      this.places = <HubPlace[]>this.allEventsOrPlaces.slice(start, end);
      this.processMultiColumnsItems();
      if (!this.isMobile) {
        this.parent.showOnMap({items: this.places, index: null});
      }
    }
    this.showingCount = `${start + 1} - ${end}`;
    this.noMoreNext = false;
    this.scrollToTop();
    this.fitBounds();
  }

  public pagingNext() {
    if (this.noMoreNext) {
      return;
    }

    this.paginationIndex++;
    let start = this.paginationPageLimit * this.paginationIndex;
    let end = start + this.paginationPageLimit;
    if (end >= this.allEventsOrPlaces.length) {
      end = this.allEventsOrPlaces.length;
      this.noMoreNext = true;
    }
    if (this.displayingOn === 'event') {
      this.events = <HubEvent[]>this.allEventsOrPlaces.slice(start, end);
      this.events = this.setEventMapIcon(this.events || []);
      this.processMultiColumnsItems();
      if (!this.isMobile) {
        this.parent.showOnMap({items: this.events, index: null});
      }
    } else if (this.displayingOn === 'place') {
      this.places = <HubPlace[]>this.allEventsOrPlaces.slice(start, end);
      this.processMultiColumnsItems();
      if (!this.isMobile) {
        this.parent.showOnMap({items: this.places, index: null});
      }
    }
    this.showingCount = `${start + 1} - ${end}`;
    this.noMoreBack = false;
    this.isPaginationInitStatus = false;
    this.scrollToTop();
    this.fitBounds();
  }

  public onCloseFloatDetail() {
    this.parent.visiblePopup();
    if (this.mobileMapTrigger) {
      this.mobileMapTrigger.nativeElement.style.display = 'block';
    }
  }

  public locateOnMap($event, index) {
    if ($event && $event.address && !isNullOrUndefined($event.address.lat)) {
      let target = [];
      if (this.displayingOn === 'event') {
        target = this.events;
      } else if (this.displayingOn === 'place') {
        target = this.places;
      }
      this.showInfoWindowOnMap.emit({items: target, index: index});
      //this.attractionlist.closeDetails();
    }
  }

  public showDetails(item: any, displayingOn: string, isShowAddToTripBtn = true, index?: number) {
    if (!item) {
      return;
    }

    if (!this.isMobile && this.detailsStyle === 'popup') {
      item['from'] = 'trip';
      item.hubName = this.hubName;
      if (displayingOn === 'place') {
        let actions = <PlaceDetailsModalActions>{
          confirm: (event: ButtonTriggerEvent, data: any) => {
          },
        };

        this.modalService.show({
          component: PlaceDetailsModalComponent,
          providers: [
            {provide: PlaceDetailsModalActions, useValue: actions},
            {provide: HubPlace, useValue: item},
          ],
          panelClass: 'modal-fixed-top',
        });
      } else if (displayingOn === 'event') {
        item.from = 'trip';
        let actions = <EventDetailsModalActions>{
          confirm: (event: ButtonTriggerEvent, data: any) => {
          },
        };

        this.modalService.show({
          component: EventDetailsModalComponent,
          providers: [
            {provide: EventDetailsModalActions, useValue: actions},
            {provide: HubEvent, useValue: item},
          ],
          panelClass: 'modal-fixed-top-lower',
        });
      }

      return;
    }

    let height = null;
    let top = '108px';
    let left = '0';

    if (!this.isMobile) {
      height = `${this.parent.bg.nativeElement.offsetHeight}px`;
      // top = this.featuresToggle.multipleCities ? '197px' : '99px';
      // left = 'calc(30% - 8px)';
      top = '0';
      left = 'calc(100% - 16px)';
    } else {
      top = '92px';
      if (this.parent.isShowDirectionMap || this.parent.isShowNormalMap) {
        top = '0px';
      }
      this.showTripDetailModalForMobile(item, displayingOn, isShowAddToTripBtn, index);
      return;
    }
    if (!this.isMobile && index !== null && index !== undefined && !item.isOnlineEvent) {
      this.locateOnMap(item, index);
      this.parent.setMapCenter(item.address.lat || item.lat, item.address.lng || item.lng);
    }

    this.detailsPanel.showDetails({item, feedType: displayingOn}, left, top, height);
  }

  public showTripDetailModalForMobile(item: any, displayingOn: string, isShowAddToTripBtn = true, index?: number) {
    let actions = <TripDetailModalActions>{
      confirm: (event: ButtonTriggerEvent) => {
      },
    };
    this.modalService.show({
      component: TripDetailModalComponent,
      providers: [
        {provide: TripDetailModalActions, useValue: actions},
        {
          provide: TripDetailModalData,
          useValue: new TripDetailModalData(
            item,
            displayingOn,
            this.hubName,
            this.parent.urlTripID,
            this.parent.urlTripFromUserID,
            isShowAddToTripBtn,
            index
          ),
        },
      ],
      panelClass: ['width-modal-100p', 'ig-trip-info-modal'],
    });
  }

  public filterPlace($event) {
    console.log($event);

    this.isSwitching = true;

    this.visitorApiService
      .getPlaces(this.hubName, {
        limit: config.placeSearchLimit,
        page: 1,
        category: null,
        categoryList: null,
        feedId: null,
        feedIds: null,
        source: this.dataSource.place,
      })
      .subscribe((data) => {
        let places = data;
        this.afterGotPlaces(places);
        this.isSwitching = false;
      });

    this.customDefaultPlaceAccordion && this.customDefaultPlaceAccordion.clearFilter();
    this.customDefaultPlaceAccordion && this.customDefaultPlaceAccordion.close();
  }

  public selectCustomDefaultPlaceCategory($event: PlaceType) {
    console.log({$event});

    this.isSwitching = true;

    this.visitorApiService
      .getPlaces(this.hubName, {
        limit: config.placeSearchLimit,
        page: 1,
        category: null,
        categoryList: $event.categoryList,
        feedId: null,
        feedIds: null,
        source: this.dataSource.place,
      })
      .subscribe((data) => {
        let places = data;
        this.afterGotPlaces(places);
        this.isSwitching = false;
      });

    $event && this.customDefaultPlaceAccordion && this.customDefaultPlaceAccordion.setFilter($event.title);
    !$event && this.customDefaultPlaceAccordion && this.customDefaultPlaceAccordion.clearFilter();

    this.customDefaultPlaceAccordion && this.customDefaultPlaceAccordion.close();
  }

  public FBLogin() {
    //this.parent.loginWithFBBtn.login();
  }

  public floatDetailShown($event) {
    this.onFloatDetailShown.emit($event);
  }

  public floatDetailClosed($event) {
    this.onFloatDetailClosed.emit($event);
  }

  public floatDetailFeedsClosed($event) {
    this.onFloatDetailFeedsClosed.emit($event);
  }

  public floatDetailPlaceFeedsRetrieved($event) {
    this.onFloatDetailPlaceFeedsRetrieved.emit($event);
  }

  public showTour(item: any, index?: number) {
    if (this.tourSpinner && this.tourSpinner.length > index) {
      this.tourSpinner[index] = true;
    }
    this.parent.showTourDetail(item);
  }

  public hideTourSpinner() {
    if (this.tours && this.tours.length) {
      this.tourSpinner = [];
      this.tours.forEach((x) => {
        this.tourSpinner.push(false);
      });
    }
  }

  public mapReady() {
    this.onMapReady.emit();
  }

  public printTourOrTrip(trips, isPrintVersion: boolean, type = PDFType.trip, headerImage = null, $event = null) {
    let items = [];
    trips.forEach((trip) => {
      items.push({isTripTitle: true, tripTitle: trip.title});
      trip.attractions.forEach((x) => {
        items.push(x.item);
      });
    });

    this.getStyleAndPrint(items, isPrintVersion, type, headerImage, $event);
  }

  public printTrip(isPrintVersion: boolean, $event?: ButtonTriggerEvent) {
    if (this.isMobile) {
      if (window.location !== window.parent.location) {
        console.log('iframe');
        let urlBase = null;
        if (window.location.href.indexOf('/trips') > 0) {
          urlBase = window.location.href.substr(0, window.location.href.indexOf('/trips'));
        } else if (window.location.href.indexOf('/region') > 0) {
          urlBase = window.location.href.substr(0, window.location.href.indexOf('/region'));
        }

        let tripId = guid();
        this.visitorApiService
          .createTripTemp(this.hubName, {
            id: tripId,
            hubName: this.hubName,
            trips: JSON.stringify(this.currentTrip || this.trips),
          })
          .subscribe(() => {
            this.modalService.show({
              component: MobileIFrameExportPdfAlertModal,
              providers: [
                {
                  provide: MobileIFrameExportPdfAlertModalData,
                  useValue: new MobileIFrameExportPdfAlertModalData(
                    `${urlBase}/pdf/trip/${tripId}/${isPrintVersion ? 'print' : 'online'}`
                  ),
                },
              ],
            });
          });
        return;
      } else {
        console.log('not iframe');
      }
    }

    this.downloadingPDFSpinner();
    this.printTourOrTrip(
      this.currentTrip ? [this.currentTrip] : this.trips,
      isPrintVersion,
      PDFType.trip,
      null,
      $event
    );
  }

  public printTour(isPrintVersion: boolean, $event?: ButtonTriggerEvent) {
    if (!this.currentTour || !this.currentTour.attractions.length) {
      return;
    }

    if (this.isMobile) {
      if (window.location !== window.parent.location) {
        console.log('iframe');
        let urlBase = null;
        if (window.location.href.indexOf('/trips') > 0) {
          urlBase = window.location.href.substr(0, window.location.href.indexOf('/trips'));
        } else if (window.location.href.indexOf('/region') > 0) {
          urlBase = window.location.href.substr(0, window.location.href.indexOf('/region'));
        }
        this.modalService.show({
          component: MobileIFrameExportPdfAlertModal,
          providers: [
            {
              provide: MobileIFrameExportPdfAlertModalData,
              useValue: new MobileIFrameExportPdfAlertModalData(
                `${urlBase}/pdf/tour/${this.currentTour._id}/${isPrintVersion ? 'print' : 'online'}`
              ),
            },
          ],
        });
        if (config.isAnalyticsOn) {
          this.visitorApiService.addDownloadCount(this.hubName, this.currentTour._id).subscribe();
        }
        return;
      } else {
        console.log('not iframe');
      }
    }

    this.downloadingPDFSpinner();
    if (this.currentTour.image) {
      this.printTourOrTrip(
        [this.currentTour],
        isPrintVersion,
        PDFType.tour,
        this.imageService.imageSourceUrl(this.currentTour.image),
        $event
      );
    } else {
      this.printTourOrTrip([this.currentTour], isPrintVersion, PDFType.tour, null, $event);
    }
    if (config.isAnalyticsOn) {
      this.visitorApiService.addDownloadCount(this.hubName, this.currentTour._id).subscribe();
    }
  }

  private getStyleAndPrint(items, isPrintVersion, type, headerImage, $event = null) {
    this.customizationApiService.getStyleAndPDFSettings(this.hubName).subscribe((style) => {
      const tripHeaderImage = (style.pdf.headerImage.tour.url && !style.pdf.headerImage.tour.isDefault) ? style.pdf.headerImage.tour.url : headerImage || null;
      this.logoUrl =
        isNullOrUndefined(style.logo) || isNullOrUndefined(style.logo.isDefault) || style.logo.isDefault
          ? null
          : style.logo.url;
      this.logo = style.logo;
      this.parent.setPDFLoadingTip([18, 19, 20, 21]);

      this.imageService.geetBase64ImageByUrl(this.logoUrl).then((base64) => {
        this.parent.setPDFLoadingTip([23, 24, 25, 26]);
        this.visitorApiService.convertGoogleImages(this.hubName, items).subscribe((converted) => {
          this.exportService.exportPDF(
            converted,
            type,
            isPrintVersion,
            tripHeaderImage,
            isNullOrUndefined(this.logo.isDefault) || this.logo.isDefault ? null : base64,
            style.URLs.eventCalendarURL,
            style.URLs.placeCalendarURL,
            style.URLs.moreToursURL,
            null,
            null,
            '',
            style.style.eventButton.backgroundColor,
            $event || undefined,
            (progress) => {
              let per = Math.max(26, progress);
              this.parent.loadingTip = `Loading PDF...(${per}%)`;
            },
            () => {
              this.isDownloadingPDF = false;
              if (this.parent.isForExportPDF) {
                this.parent.pageSpinner && this.parent.pageSpinner.hide();
              }
            }
          );
        });
      });
    });
  }

  private downloadingPDFSpinner() {
    this.isDownloadingPDF = true;
    // setTimeout(() => {
    //     this.isDownloadingPDF = false;
    // }, this.isMobile ? 60000 : 15000);
  }

  public filterEventsByDate(searchText, from, to) {
    if (this.displayingOn === 'event') {
      if (!this.category.event) {
        this.events = [];
        this.showingCount = null;
        return;
      }
      if (from) {
        from.setHours(0);
        from.setMinutes(0);
        from.setSeconds(0);
      }
      if (to) {
        to.setHours(23);
        to.setMinutes(59);
        to.setSeconds(59);
      }
      this.isSwitching = true;
      this.visitorApiService
        .getEvents(this.hubName, {
          limit: config.searchLimit,
          page: 1,
          category: this.category.event,
          search: searchText,
          from,
          to,
        })
        .subscribe((data) => {
          EventTimeService.formatEventTime(data);
          this.allEventsOrPlaces = data;
          this.setPaggination(data);
          if (this.parent.isShowNormalMap) {
            this.parent.start();
          }
          this.hideMask();
        });
    }
  }

  public search(searchText, from, to) {
    this.detailsPanel.closeDetails();
    if (searchText) {
      this.isSearch = true;
      this.parent.searchOnDesktop.searching = true;
    } else {
      this.isSearch = false;
      this.parent.searchOnDesktop.searching = false;
    }
    if (this.displayingOn === 'event') {
      if (!this.category.event) {
        this.events = [];
        this.showingCount = null;
        return;
      }
      this.isSwitching = true;
      this.visitorApiService
        .getEvents(this.hubName, {
          limit: config.searchLimit,
          page: 1,
          category: this.category.event,
          search: searchText,
          from,
          to,
        })
        .subscribe((data) => {
          EventTimeService.formatEventTime(data);
          this.allEventsOrPlaces = data;
          this.setPaggination(data);
          this.processMultiColumnsItems();
          this.hideMask();
          this.parent.searchOnDesktop.searching = false;
        });
    } else if (this.displayingOn === 'place') {
      let category = !searchText ? this.category.place : 'all';
      this.isSwitching = true;
      this.visitorApiService
        .getPlaces(this.hubName, {
          limit: config.placeSearchLimit,
          page: 1,
          category: category,
          search: searchText,
          source: this.dataSource.place,
        })
        .subscribe((data) => {
          this.setPlaceMapIcon(data);
          this.allEventsOrPlaces = data;
          this.displayingOn = 'place';
          this.setPaggination(data);
          this.processMultiColumnsItems();
          this.hideMask();
          this.parent.searchOnDesktop.searching = false;
        });
    }
  }

  public toggleFilter(canDo?) {
    if (!canDo) {
      return;
    }
    if (this.displayingOn === 'tour') {
      this.switchToTours();
      return;
    }
    if (this.displayingOn === 'event' || this.displayingOn === 'place') {
      // if (this.displayingOn === 'place' || (this.isMobile && this.displayingOn === 'event')) {
      this.isShowFilter = !this.isShowFilter;
      if (this.isShowFilter) {
        this.filterElement.nativeElement.style.height =
          this.displayingOn.toString() === 'event'
            ? '34px'
            : this.displayingOn === 'place'
              ? this.placeCategoryHeight
              : '0px';
        this.filterElement.nativeElement.style.paddingTop = '16px';
        this.cardWrap.nativeElement.style.transition = '300ms all';
        if (!this.isMobile) {
          this.cardWrap.nativeElement.style.height = this.cardContainerPlaceHeight;
          this.cardWrap.nativeElement.style.maxHeight = this.cardContainerPlaceHeight;
        } else {
          setTimeout(() => {
            this.scrollToTop();
          });
        }
      } else {
        this.filterElement.nativeElement.style.height = '0px';
        this.filterElement.nativeElement.style.paddingTop = '0';
        this.cardWrap.nativeElement.style.transition = '300ms all';
        setTimeout(() => {
          this.cardWrap.nativeElement.style.height = this.cardContainerMaxHeight;
          //this.cardWrap.nativeElement.style.maxHeight = this.cardContainerMaxHeight;
        });
      }
    }

    setTimeout(() => {
      if (this.displayingOn === 'event' && (!this.events || !this.events.length)) {
        this.cardWrap.nativeElement.style.height = 'auto';
      }
      if (this.displayingOn === 'place' && (!this.places || !this.places.length)) {
        this.cardWrap.nativeElement.style.height = 'auto';
      }

      // fix the place list blank issue
      if (this.displayingOn === 'place' && this.isMobile) {
        this.placeMask.nativeElement.style.opacity = 0.1;
        this.placeMask.nativeElement.style.display = 'block';
        setTimeout(() => {
          this.placeMask.nativeElement.style.opacity = 0;
          this.placeMask.nativeElement.style.display = 'none';
        }, 500);
      }
    });
  }

  public setAllPlaceCategoryUnSelected() {
    for (let cate in this.filter.place) {
      this.filter.place[cate].value = false;
    }
  }

  public resetPlaceCategoty() {
    this.setAllPlaceCategoryUnSelected();
    this.category.place = 'Dining & Nightlife';
    this.filter.place.dining.value = true;
    this.isSearch = false;
    VisitorDataCache.places = null;
  }

  public filterCategory(category, closeStartPage = false) {
    if (closeStartPage === true) {
      this.closePlaceCategoryStartPage();
      this.filter.place.dining.value = false;
    }

    // only select current category, per ITI's request
    for (let key in this.filter[this.displayingOn]) {
      if (!Object.hasOwnProperty(key)) {
        this.filter[this.displayingOn][key].value = false;
      }
    }

    if (!isNullOrUndefined(category)) {
      category.value = !category.value;
    }

    this.category[this.displayingOn] = '';
    this.equipCategory();
    this.switchToPlaces(false);
    return;
  }

  public reordered($event) {
    if (!this.trips || !$event.attractions.length) {
      return;
    }
    if ($event.type === 'trip') {
      let userID;
      if (this.isUserloggedIn) {
        userID = SocialLoginPopupComponent.userId;
      }

      let key = LocalStorageService.getLocalStorageKeyForVisitorTrip(this.hubName);
      let keyWithUserID = LocalStorageService.getLocalStorageKeyForVisitorTrip(this.hubName, userID);
      let tripWithUserID = JSON.parse(localStorage.getItem(keyWithUserID)) as TripStorageCommand;
      if (tripWithUserID && tripWithUserID.trips[this.currentTripIndex].attractions.length) {
        tripWithUserID.trips[this.currentTripIndex].attractions = $event.attractions;
        tripWithUserID.trips[this.currentTripIndex].attractions =
          tripWithUserID.trips[this.currentTripIndex].attractions.removeDuplicate();
        tripWithUserID.timestamp = new Date();
        localStorage.setItem(key, JSON.stringify(tripWithUserID));
        localStorage.setItem(keyWithUserID, JSON.stringify(tripWithUserID));
        if (userID) {
          this.visitorApiService.updateTrip(this.hubName, tripWithUserID).subscribe();
        }
      }

      this.trips[this.currentTripIndex].attractions = $event.attractions;
    }
    if (!this.isMobile) {
      this.tripListReordered.emit(this.trips[this.currentTripIndex]);
    }
  }

  public removeFromTrip(id, tripIndex?) {
    if (id) {
      if (this.isUserloggedIn) {
        this.userFacebookID = SocialLoginPopupComponent.userId;

        if (!this.parent.urlTripID || this.parent.urlTripFromUserID === this.userFacebookID) {
          this.removeTripItemFromDB(id, !isNullOrUndefined(tripIndex) ? tripIndex : this.currentTripIndex);
        }
      }
      this.removeFromLocalStorage(id, tripIndex);
      let trip = this.getTripFromLocalStorage(this.currentTripIndex);
      this.removeFromTripEvent.emit(trip);
    }
  }

  public tripCoverImage(trip) {
    if (trip && trip.attractions && trip.attractions.length) {
      return trip.attractions[0].item.cover
        ? trip.attractions[0].item.cover.source || this.tripImages[0]
        : this.tripImages[0];
    }
    return this.tripImages[0];
  }

  public addNewTripToLocalStorage(title, item?, type?) {
    let key = LocalStorageService.getLocalStorageKeyForVisitorTrip(this.hubName);
    let keyWithUserID = LocalStorageService.getLocalStorageKeyForVisitorTrip(this.hubName, this.userFacebookID);
    let trips = JSON.parse(localStorage.getItem(key)) as TripStorageCommand;
    let newTrip = new CreateTripCommand();
    if (!trips || !trips.trips || !trips.trips.length) {
      trips = new TripStorageCommand();
    } else {
      if (trips.trips.length >= this.maxTripCount) {
        return;
      }
    }
    newTrip.attractions = [];
    if (item) {
      newTrip.attractions.push({
        feedType: type,
        feedId: item._id,
        order: 1,
        item: item,
      });
    }
    newTrip.title = title;
    newTrip.timestamp = new Date();
    newTrip.hubName = this.hubName;
    newTrip.img = this.assignTripImage();
    trips.trips.push(newTrip);

    let tripsWithUserId = clone(trips);
    localStorage.setItem(key, JSON.stringify(trips));
    tripsWithUserId.userFacebookId = this.userFacebookID || null;
    localStorage.setItem(keyWithUserID, JSON.stringify(tripsWithUserId));

    return trips;
  }

  public createTrip() {
    this.createNewTrip();
    //this.trips = this.setTripImages(this.trips);
    this.isEditTripModes[this.trips.length - 1] = true;
    this.isEditTripMode = true;
    this.tripTitleSelect();
    this.scrollToBottom();
  }

  public deleteTrip(index, id) {
    let actions = <ConfirmModalActions>{
      confirm: (event: ButtonTriggerEvent) => {
        if (this.isUserloggedIn) {
          this.visitorApiService
            .deleteTrip(this.hubName, {
              id,
              userFacebookId: this.userFacebookID,
            })
            .subscribe();
        }
        let key = LocalStorageService.getLocalStorageKeyForVisitorTrip(this.hubName);
        let keyWithUserID = LocalStorageService.getLocalStorageKeyForVisitorTrip(this.hubName, this.userFacebookID);
        let trips = JSON.parse(localStorage.getItem(key)) as TripStorageCommand;
        if (!trips || !trips.trips || !trips.trips.length) {
          this.trips = [];
        } else if (trips.trips.length === 1) {
          localStorage.removeItem(key);
          localStorage.removeItem(keyWithUserID);
          this.trips = [];
        } else {
          trips.trips.splice(index, 1);
          let tripsWithUserId = clone(trips);
          localStorage.setItem(key, JSON.stringify(trips));
          tripsWithUserId.userFacebookId = this.userFacebookID || null;
          localStorage.setItem(keyWithUserID, JSON.stringify(tripsWithUserId));
          this.trips = trips.trips;
        }
        if (!this.trips.length) {
          this.backToWelcomePage();
        }
        //this.setTripImages(this.trips);
        this.backToTripList();
        event.complete();
      },
    };

    let data = <ConfirmModalData>{
      confirmModalIcon: 'warning',
      confirmModalTitle: 'Alert',
      confirmModalDescription: `Are you sure you want to remove this trip?`,
      confirmModalConfirmButtonText: 'Remove',
      confirmModalCancelButtonText: 'Cancel',
      isAsync: true,
    };

    this.modalService.show({
      component: ConfirmModalComponent,
      providers: [
        {provide: ConfirmModalActions, useValue: actions},
        {provide: ConfirmModalData, useValue: data},
      ],
    });
  }

  public isInTrip(tripIndex, itemId) {
    let trip = this.getTripFromLocalStorage(tripIndex);
    if (!trip) {
      return false;
    }
    return trip.attractions.any((x) => x.item._id === itemId);
  }

  public showShareTripModal(type) {
    //let {tripId, hubName} = this.allRouteParams;
    let shareTripModalData = null;
    if (type === 'trip') {
      let trip = this.loadTripsInLocalStorage();
      let wholeTripId = trip ? trip.id : null;
      let singleTripId = this.currentTrip ? this.currentTrip.id : null;
      let singleTripTitle = this.currentTrip ? this.currentTrip.title : null;

      shareTripModalData = new ShareTripModalData(
        wholeTripId,
        this.hubName,
        type,
        !this.currentTrip,
        singleTripId,
        singleTripTitle,
        this.currentTripIndex
      );
    } else {
      shareTripModalData = new ShareTripModalData(this.currentTour._id, this.hubName, type, false, '', '', 0);
    }

    let actions = <ShareTripModalActions>{
      confirm: (event: ButtonTriggerEvent, social) => {
        social === 'fb' ? this.parent.socialLogin.fbLoginBtn.login() : this.parent.socialLogin.googleLoginBtn.login();
      },
    };

    this.modalService.show({
      component: ShareTripModalComponent,
      providers: [
        {provide: ShareTripModalActions, useValue: actions},
        {
          provide: ShareTripModalData,
          useValue: shareTripModalData,
        },
      ],
    });
  }

  public get isSharedTrip() {
    return this.parent.urlTripID && this.parent.urlTripFromUserID !== this.userFacebookID;
  }

  public showCreateTripModal(isFromSideBar = false, addThisItem = null, type = null, callback = null) {
    if (this.currentTripsCount >= this.maxTripCount) {
      alert('You have created too many trips...');
      return;
    }
    let actions = <CreateTripModalActions>{
      confirm: (tripTitle: string, event: ButtonTriggerEvent) => {
        this.createNewTrip(tripTitle, addThisItem, type, callback);
        if (isFromSideBar) {
          this.scrollToBottom();
        }
      },
    };
    this.modalService.show({
      component: CreateTripModalComponent,
      providers: [{provide: CreateTripModalActions, useValue: actions}],
    });
  }

  public enterTripOrEnterEditTitle(index) {
    if (this.currentTrip) {
      this.enterEditTripTitleMode(index);
    } else {
      this.enterTrip(index);
    }
  }

  public enterTrip(index) {
    if (this.isSharedTrip) {
      this.currentTrip = this.getSharedTripFromLocalStorage(index);
    } else {
      this.currentTrip = this.getTripFromLocalStorage(index);
    }
    this.currentTripIndex = index;
    if (!this.isMobile) {
      this.parent.showDirectionMap(this.currentTrip);
    }
    this.parent.direction && this.parent.direction.hideBanner();

    setTimeout(() => {
      if (this.parent.isForExportPDF) {
        this.printTrip(this.parent.isPrintVersion);
      }
    });
  }

  public backToTripList() {
    this.currentTrip = null;
    this.currentTripIndex = -1;
    this.exitEditTripTitleMode();
    if (!this.isMobile && this.parent.direction) {
      this.parent.direction.showBanner();
    }
  }

  public backToTourList() {
    this.currentTour = null;
    this.currentTrip = null;
  }

  public exitEditTripTitleMode() {
    this.isEditTripModes = [];
    this.trips.forEach(() => {
      this.isEditTripModes.push(false);
    });
    this.isEditTripMode = false;
  }

  public get isUserloggedIn() {
    return SocialLoginPopupComponent.isUserLoggedIn;
  }

  public enterEditTripTitleMode(index) {
    if (!isNullOrUndefined(index)) {
      this.isEditTripModes = [];
      this.trips.forEach(() => {
        this.isEditTripModes.push(false);
      });
      this.isEditTripModes[index] = true;
      this.isEditTripMode = true;
      this.tripTitleSelect();
    }
  }

  public setTripTitle(title, index) {
    if (!isNullOrUndefined(index)) {
      if (this.isUserloggedIn) {
        this.visitorApiService
          .updateTripTitle(this.hubName, {
            tripIndex: index,
            title,
            userFacebookId: this.userFacebookID,
          })
          .subscribe();
      }

      let key = LocalStorageService.getLocalStorageKeyForVisitorTrip(this.hubName);
      let keyWithUserID = LocalStorageService.getLocalStorageKeyForVisitorTrip(this.hubName, this.userFacebookID);
      let trips = JSON.parse(localStorage.getItem(key)) as TripStorageCommand;
      if (trips && trips.trips && trips.trips.length > index) {
        trips.trips[index].title = title;

        let tripsWithUserId = clone(trips);
        localStorage.setItem(key, JSON.stringify(trips));
        tripsWithUserId.userFacebookId = this.userFacebookID || null;
        localStorage.setItem(keyWithUserID, JSON.stringify(tripsWithUserId));
      }

      this.isEditTripModes[index] = false;
      this.isEditTripMode = false;
    }
  }

  public createNewTrip(title?, addThisItem?, type?, callback?) {
    let img = this.assignTripImage();
    let attractions = [];
    if (addThisItem) {
      attractions.push({feedId: addThisItem._id, feedType: type, order: 1});
    }
    if (this.isUserloggedIn) {
      this.visitorApiService
        .createTrip(this.hubName, {
          id: guid(),
          userFacebookId: this.userFacebookID,
          description: '',
          hubName: this.hubName,
          newTrip: {id: guid(), title: title || this.defaultNewTripTitle, img, attractions: attractions},
          trips: [],
        })
        .subscribe(() => {
        });
    }
    this.trips = this.addNewTripToLocalStorage(title || this.defaultNewTripTitle, addThisItem, type).trips;
    this.notifyAddOrRemoveItemStore.notifyCommand.next(null);
    if (callback) {
      callback();
    }
  }

  public addItemToTrip(param) {
  }

  public loadTripsInLocalStorage() {
    let key = LocalStorageService.getLocalStorageKeyForVisitorTrip(this.hubName);
    let trips = JSON.parse(localStorage.getItem(key)) as TripStorageCommand;
    if (!trips || !trips.trips || !trips.trips.length) {
      trips = new TripStorageCommand();
    }
    this.trips = trips.trips;
    return trips;
  }

  public loadTripsInLocalStorageByUserId() {
    let keyWithUserID = LocalStorageService.getLocalStorageKeyForVisitorTrip(this.hubName, this.userFacebookID);
    let trips = JSON.parse(localStorage.getItem(keyWithUserID)) as TripStorageCommand;
    if (!trips || !trips.trips || !trips.trips.length) {
      trips = new TripStorageCommand();
    }
    this.trips = trips.trips;
    return trips;
  }

  public loadSharedTripsInLocalStorage(userID) {
    let keyWithUserIDShared = LocalStorageService.getLocalStorageKeyForVisitorTrip(this.hubName, userID, true);
    let trips = JSON.parse(localStorage.getItem(keyWithUserIDShared)) as TripStorageCommand;
    if (!trips || !trips.trips || !trips.trips.length) {
      trips = new TripStorageCommand();
    }
    this.trips = trips.trips;
  }

  public removeFromLocalStorage(id, tripIndex?) {
    this.setFacebookUserID();
    tripIndex = isNullOrUndefined(tripIndex) ? this.currentTripIndex : tripIndex;
    if (this.parent.urlTripID && this.parent.urlTripFromUserID !== this.userFacebookID) {
      let keyWithUserIDShared = LocalStorageService.getLocalStorageKeyForVisitorTrip(
        this.hubName,
        this.parent.urlTripFromUserID,
        true
      );
      let trip = JSON.parse(localStorage.getItem(keyWithUserIDShared)) as CreateTripCommand;

      if (trip && trip.attractions && trip.attractions.length) {
        let index = trip.attractions.getElementIndex((x) => x.feedId === id);
        trip.attractions.splice(index, 1);
      }
      trip.attractions = trip.attractions.removeDuplicate();
      if (trip.attractions.length) {
        trip.timestamp = new Date();
        localStorage.setItem(keyWithUserIDShared, JSON.stringify(trip));
      } else {
        localStorage.removeItem(keyWithUserIDShared);
      }
      this.trips = trip;
      return;
    }
    let key = LocalStorageService.getLocalStorageKeyForVisitorTrip(this.hubName);
    let keyWithUserID = LocalStorageService.getLocalStorageKeyForVisitorTrip(this.hubName, this.userFacebookID);
    let trip = JSON.parse(localStorage.getItem(key)) as TripStorageCommand;

    if (!trip || !trip.trips || trip.trips.length <= tripIndex) {
      return;
    }

    if (trip.trips[tripIndex] && trip.trips[tripIndex].attractions.length) {
      let index = trip.trips[tripIndex].attractions.getElementIndex((x) => x.feedId === id);
      trip.trips[tripIndex].attractions.splice(index, 1);
    }
    trip.trips[tripIndex].attractions = trip.trips[tripIndex].attractions.removeDuplicate();
    trip.timestamp = new Date();
    localStorage.setItem(key, JSON.stringify(trip));
    localStorage.setItem(keyWithUserID, JSON.stringify(trip));

    this.trips = trip.trips;
  }

  private setDetaultImages(trips) {
    trips.forEach((trip) => {
      if (trip.attractions && trip.attractions.length) {
        trip.attractions.forEach((x) => {
          // for those events use default images, need to load image from events cache
          if (!x.item.cover && x.feedType === 'event') {
            for (let event of VisitorDataCache.events) {
              if (event._id === x.feedId) {
                x.item.cover = event.cover;
                break;
              }
            }
          }
        });
      }
    });
    return trips;
  }

  private setTripImages(trips) {
    let index = 0;
    this.isEditTripModes = [];
    trips.forEach((x) => {
      if (index < this.tripImages.length) {
        x.img = this.tripImages[index];
        index++;
        if (index == this.tripImages.length) {
          index = 0;
        }
      }
      this.isEditTripModes.push(false);
    });
    return trips;
  }

  private getTripFromLocalStorage(tripIndex) {
    let key = LocalStorageService.getLocalStorageKeyForVisitorTrip(this.hubName);
    let trip = JSON.parse(localStorage.getItem(key)) as TripStorageCommand;
    if (!trip || !trip.trips || !trip.trips.length) {
      return null;
    }
    if (tripIndex >= trip.trips.length) {
      return null;
    }
    return trip.trips[tripIndex];
  }

  private getSharedTripFromLocalStorage(tripIndex) {
    let key = LocalStorageService.getLocalStorageKeyForVisitorTrip(this.hubName, this.parent.urlTripFromUserID, true);
    let trip = JSON.parse(localStorage.getItem(key)) as TripStorageCommand;
    if (!trip || !trip.trips || !trip.trips.length) {
      return null;
    }
    if (tripIndex >= trip.trips.length) {
      return null;
    }
    return trip.trips[tripIndex];
  }

  private tripTitleSelect() {
    setTimeout(() => {
      this.tripTitleInput.input.nativeElement.selectionStart = 0;
    });
  }

  private removeTripItemFromDB(id, tripIndex) {
    this.visitorApiService
      .removeAtractionFromTrip(this.hubName, {
        feedId: id,
        userFacebookId: this.userFacebookID,
        tripIndex,
      })
      .subscribe();
  }

  private equipCategory() {
    this.placeCategoryCount = 0;
    for (let key in this.filter[this.displayingOn]) {
      if (!Object.hasOwnProperty(key)) {
        if (!this.filter[this.displayingOn][key].value) {
          if (this.category[this.displayingOn].indexOf(this.filter[this.displayingOn][key].key) >= 0) {
            this.category[this.displayingOn] = this.category[this.displayingOn].replace(
              `,${this.filter[this.displayingOn][key].key}`,
              ''
            );
          }
        } else {
          this.placeCategoryCount++;
          if (this.category[this.displayingOn].indexOf(this.filter[this.displayingOn][key].key) < 0) {
            this.category[this.displayingOn] += `,${this.filter[this.displayingOn][key].key}`;
          }
        }
      }
    }
    if (this.category[this.displayingOn].startsWith(',')) {
      this.category[this.displayingOn] = this.category[this.displayingOn].substr(1);
    }
    console.log(this.category[this.displayingOn]);
  }

  private addingAnimation(param) {
    if (!this.countIcon) {
      return;
    }
    this.countIcon.nativeElement.style.transition = 'none';
    this.countIcon.nativeElement.style.top = `${param.event.clientY - 12}px`;
    this.countIcon.nativeElement.style.left = `${param.event.clientX - 12}px`;
    this.countIcon.nativeElement.style.display = `block`;

    setTimeout(() => {
      this.countIcon.nativeElement.style.transition = 'all 0.7s cubic-bezier(.94,-0.25,.32,1.31)';

      if (this.isMobile) {
        this.countIcon.nativeElement.style.left = `calc(100% - 24px)`;
        this.countIcon.nativeElement.style.top = `43px`;
      } else {
        this.countIcon.nativeElement.style.left = `calc(30% - 25px)`;
        this.countIcon.nativeElement.style.top = `90px`;
      }
    });
  }

  private removingAnimation() {
    if (!this.countIcon) {
      return;
    }
    this.countIcon.nativeElement.style.transition = 'all 0.3s';
    this.countIcon.nativeElement.style.background = '#ff0000';
    if (this.countBaseIcon) {
      this.countBaseIcon.nativeElement.style.transition = 'all 0.3s';
      this.countBaseIcon.nativeElement.style.background = '#ff0000';
    }

    setTimeout(() => {
      this.countIcon.nativeElement.style.background = '#eec30d';
      if (this.countBaseIcon) {
        this.countBaseIcon.nativeElement.style.background = '#eec30d';
      }
    }, 300);
  }

  public getTripCount(userID?) {
    this.setFacebookUserID();
    let isShared = false;
    let userFacebookID = userID || this.userFacebookID;
    if (this.parent.urlTripID && this.parent.urlTripFromUserID !== userFacebookID) {
      userFacebookID = this.parent.urlTripFromUserID;
      isShared = true;
    }
    let key = LocalStorageService.getLocalStorageKeyForVisitorTrip(this.hubName, userFacebookID, isShared);
    let storage = localStorage.getItem(key);
    let trip = JSON.parse(storage) as CreateTripCommand;
    if (trip && trip.attractions && trip.attractions.length) {
      let array = trip.attractions.removeDuplicate();
      this.tripCount = array.length;
    }
  }

  public openPrintMenu() {
    if (!this.isDownloadingPDF) {
      this.menuTrigger.openMenu();
    }
  }

  public get defaultNewTripTitle() {
    return this.defaultTripName + (this.currentTripsCount + 1);
  }

  public showPlaceCategoryStartPage() {
    this.placeCategoryMask.nativeElement.style.display = 'block';
    this.placeCategoryStartPage.nativeElement.style.display = 'block';
    this.placeCategoryCloseIcon.nativeElement.style.display = 'block';
    //this.placeStayStartPageIcon.nativeElement.style.display = 'block';
    if (!this.isMobile) {
      this.startPageIconWrap.nativeElement.style.display = 'block';
      setTimeout(() => {
        this.startPageIconWrap.nativeElement.style.width = this.cardContainer.nativeElement.clientWidth + 'px';
        this.placeCategoryStartPageTooltip.show();
      });
    }
    this.isPlaceStartPageShown = true;
  }

  public scrollDown() {
    //this.cardWrap.nativeElement.scrollTop = 1200;//this.cardWrap.nativeElement.clientHeight;
    this.cardContainer.nativeElement.style.transition = '0.3s all';
    this.cardContainer.nativeElement.scrollTop = this.cardWrap.nativeElement.clientHeight;
  }

  public closePlaceCategoryStartPage() {
    this.placeCategoryMask.nativeElement.style.display = 'none';
    this.placeCategoryStartPage.nativeElement.style.display = 'none';
    this.placeCategoryCloseIcon.nativeElement.style.display = 'none';
    this.startPageIconWrap.nativeElement.style.display = 'none';
    //this.placeStayStartPageIcon.nativeElement.style.display = 'none';
    this.placeCategoryStartPageTooltip.hide();
  }

  public get currentTripsCount() {
    let key = LocalStorageService.getLocalStorageKeyForVisitorTrip(this.hubName);
    let storage = localStorage.getItem(key);
    let trip = JSON.parse(storage) as TripStorageCommand;
    return !trip || !trip.trips || !Array.isArray(trip.trips) ? 0 : trip.trips.length;
  }

  private setPlaceMapIcon(places) {
    if (!VisitorDataCache.placeCategories) {
      this.visitorApiService.getPlaceCategories().subscribe((data) => {
        VisitorDataCache.placeCategories = clone(data);
        this.setPlaceMapIcon(places);
      });
    } else {
      let categories = VisitorDataCache.placeCategories;
      for (let place of places) {
        for (let category in categories) {
          if (!Object.hasOwnProperty(category)) {
            if (!place.mapIcon) {
              if (place.categoryList.any((x) => categories[category].any((y) => x === y))) {
                place.mapIcon = categories[category][0];
              }
            }
          }
        }
      }
    }
  }

  private getPlacesFromCache(): any[] {
    let places = VisitorDataCache.places;
    if (places && places.length) {
      let filterByCategory = [];
      if (this.category.place && this.category.place.toLowerCase() !== 'all') {
        let categories = this.category.place.split(',');
        for (let place of places) {
          for (let category of categories) {
            let categoryList = [];
            if (category === 'ThingsToDo') {
              categoryList.push(...VisitorDataCache.placeCategories['Arts & Culture']);
              categoryList.push(...VisitorDataCache.placeCategories['Activities']);
              categoryList.push(...VisitorDataCache.placeCategories['Outdoors & Fitness']);
              categoryList.push(...VisitorDataCache.placeCategories['Entertainment']);
            } else {
              categoryList = VisitorDataCache.placeCategories[category];
            }
            let categoryTextList = categoryList.map((x) => x.replace(/(_)+/g, ' ').upperFirstLetter());
            if (
              place.categoryList.any((x) => categoryTextList.any((y) => y === x) || categoryList.any((y) => x === y))
            ) {
              if (!filterByCategory.any((x) => x.id === place.id)) {
                place.mapIcon = category === 'ThingsToDo' ? 'Activities' : category;
                filterByCategory.push(place);
              }
            }
          }
        }
      } else {
        filterByCategory = places;
      }
      return filterByCategory;
    } else if (places && !places.length) {
      return [];
    }
    return null;
  }

  private getEventsFromCache(): Observable<any> {
    return Observable.create((observable) => {
      let events = VisitorDataCache.events;
      if (events && events.length) {
        events = this.setEventMapIcon(events);
        observable.next(events);
        observable.complete();
      } else {
        this.visitorApiService
          .getEvents(this.hubName, {
            limit: config.searchLimit,
            page: 1,
            category: this.category.event,
            from: this.fromForMobile,
            to: this.toForMobile,
          })
          .subscribe((data) => {
            data = this.setEventMapIcon(data);
            VisitorDataCache.events = data;
            observable.next(data);
            observable.complete();
          });
      }
    });
  }

  public setEventMapIcon(events) {
    for (let event of events) {
      event.mapIcon = 'Event';
    }
    return events;
  }

  private assignTripImage() {
    if (this.tripImageIndex >= this.tripImages.length) {
      this.tripImageIndex = 0;
    }
    return this.tripImages[this.tripImageIndex++];
  }

  private procecssPlaces(feedId = null, isGotoTours = false) {
    if (this.isLoadingAllPlaces) {
      this.isSwitching = true;
      setTimeout(() => {
        this.procecssPlaces(feedId);
      }, 500);
      return;
    }
    // let places = this.getPlacesFromCache();
    // if (!!places) {
    //     this.afterGotPlaces(places, isGotoTours);
    // } else {
    // if client turned off the showing multiple city block section in the dashboard, then get the places within the current region
    let feedIds = null;
    if (this.parent.featuresToggle.multipleCities && !this.parent.isMultiCityBlock) {
      if (this.parent.currentRegion) {
        feedIds = this.parent.currentRegion.cities.map((x) => x.id);
      }
    }

    let categoryList;
    if (!this.customDefaultPlaceCategory.useDefault) {
      this.category.place = null;
    } else {
      categoryList = undefined;
    }

    this.visitorApiService
      .getPlaces(this.hubName, {
        limit: config.placeSearchLimit,
        page: 1,
        category: this.category.place,
        categoryList,
        feedId,
        feedIds,
        source: this.dataSource.place,
      })
      .subscribe((data) => {
        VisitorDataCache.places = data;
        //   let places = this.getPlacesFromCache();
        let places = data;
        this.afterGotPlaces(places, isGotoTours);

        // load all places and save to cache to enhance UX
        if (this.customDefaultPlaceCategory.useDefault) {
          this.isLoadingAllPlaces = true;
          setTimeout(() => {
            this.visitorApiService
              .getPlaces(this.hubName, {
                limit: config.placeSearchLimit,
                page: 1,
                category: 'all',
                feedId,
                feedIds,
                source: this.dataSource.place,
              })
              .subscribe((data) => {
                VisitorDataCache.places = data;
                this.isLoadingAllPlaces = false;
                this.isSwitching = false;
              });
          }, 1000);
        }
      });
    // }
  }

  public afterGotEvents(data) {
    EventTimeService.formatEventTime(data);
    this.allEventsOrPlaces = data;
    this.displayingOn = 'event';
    !this.isShowFilter && this.toggleFilter(true);
    this.setPaggination(data);
    this.cardCountInRow = this.isMobile ? this.cardCountInRowForMobileEvent : this.cardCountInRow;
    this.processMultiColumnsItems();
    if (this.parent.isStarted && !this.isMobile) {
      this.parent.showOnMap({items: this.events, index: null});
    }

    if (!this.isMobile) {
      if (!data || !data.length) {
        this.cardWrap.nativeElement.style.height = 'auto';
      } else if (data.length <= this.paginationPageLimit) {
        this.cardContainer.nativeElement.style.maxHeight = this.cardContainerFullHeight;
        this.cardWrap.nativeElement.style.maxHeight = this.cardContainerFullHeight;
        this.cardWrap.nativeElement.style.height = this.cardContainerFullHeight;
      } else {
        //this.cardContainer.nativeElement.style.maxHeight = this.cardContainerMaxHeight;
        this.cardWrap.nativeElement.style.maxHeight = this.cardContainerMaxHeight;
        this.cardWrap.nativeElement.style.height = this.cardContainerMaxHeight;
      }
    }

    this.scrollToTop();
    this.hideMask();
    this.analytics = new HubAnalytics();
    this.analytics.tripPlanner.eventClickCount = 1;
    if (config.isAnalyticsOn) {
      this.visitorApiService.updateTripPlanerAnalytics(this.hubName, this.analytics).subscribe();
    }
  }

  private afterGotPlaces(places, isGotoTours = false) {
    this.allEventsOrPlaces = places;
    if (isGotoTours) {
      //this.switchToTours();
      return;
    }
    this.displayingOn = 'place';
    !this.isShowFilter && this.toggleFilter(true);
    if (this.isShowFilter) {
      this.filterElement.nativeElement.style.height = this.placeCategoryHeight;
      if (this.isMobile) {
        this.filterElement.nativeElement.style.height = this.placeCategoryHeightMobile;
      }
    }
    this.setPaggination(places);
    this.processMultiColumnsItems();

    if (!this.isMobile) {
      if (!places || !places.length) {
        this.cardWrap.nativeElement.style.height = 'auto';
      } else if (places.length <= this.paginationPageLimit) {
        this.cardContainer.nativeElement.style.maxHeight = this.cardContainerFullHeight;
        this.cardWrap.nativeElement.style.maxHeight = this.cardContainerFullHeightForNoPagging;
      } else {
        this.cardWrap.nativeElement.style.maxHeight = this.cardContainerPlaceHeight;
      }

      this.cardWrap.nativeElement.style.overflowY = 'auto';
      this.cardContainer.nativeElement.style.overflowY = 'hidden';
    }
    if (!places || !places.length) {
      this.cardWrap.nativeElement.style.height = 'auto';
    }

    this.scrollToTop();
    if (!this.isMobile) {
      this.parent.showOnMap({items: this.places, index: null});
    }
    this.hideMask();

    this.analytics = new HubAnalytics();
    this.analytics.tripPlanner.placeClickCount = 1;
    if (config.isAnalyticsOn) {
      this.visitorApiService.updateTripPlanerAnalytics(this.hubName, this.analytics).subscribe();
    }
  }

  private processMultiColumnsItems() {
    let targets = [];
    targets = this.displayingOn === 'place' ? this.places : this.events;
    let columns = [];
    this.placeRows = [];
    this.eventRows = [];
    targets.forEach((x, index) => {
      if (index && index % this.cardCountInRow === 0) {
        this.displayingOn === 'place' ? this.placeRows.push(columns) : this.eventRows.push(columns);
        columns = [];
      }
      columns.push(x);
      if (index === targets.length - 1) {
        this.displayingOn === 'place' ? this.placeRows.push(columns) : this.eventRows.push(columns);
      }
    });
  }

  private scrollToTop() {
    /**
     * this causes the script embed solution page jump to ImGoing, pause this for now
     * */
    // this.cardContainer.nativeElement.scrollIntoView();
    // if (this.isMobile) {
    //     this.tripCategoryWrap.nativeElement.scrollIntoView({behavior: "smooth"});
    // }
  }

  private scrollToBottom() {
    setTimeout(() => {
      this.cardWrap.nativeElement.scrollTop = this.cardWrap.nativeElement.scrollHeight;
      this.cardContainer.nativeElement.scrollTop = this.cardContainer.nativeElement.scrollHeight;
      if (this.isMobile) {
        this.parent.tripWrap.nativeElement.scrollTop = this.parent.tripWrap.nativeElement.scrollHeight;
      }
    });
  }

  private afterSetTrips(isShared, tripIndex) {
    this.addGotoUserTripCount();
    this.detailsPanel.closeDetails();
    this.parent.searchText = null;
    this.parent.isSearchDisabled = true;
    this.parent.from = null;
    this.parent.to = null;
    this.parent.isStarted = true;
    this.cardWrap.nativeElement.style.overflowY = 'auto';
    this.cardWrap.nativeElement.style.height = 'auto';
    if (isShared || (this.parent.urlTripFromUserID && this.parent.urlTripFromUserID !== this.userFacebookID)) {
      this.loadSharedTripsInLocalStorage(this.parent.urlTripFromUserID);
    } else {
      this.userFacebookID ? this.loadTripsInLocalStorageByUserId() : this.loadTripsInLocalStorage();
    }
    if (!isNullOrUndefined(tripIndex)) {
      let targetTrip = this.trips && this.trips.length > tripIndex ? this.trips[tripIndex] : null;
      if (!targetTrip) {
        alert('Wrong trip Id, please check!');
        this.switchToTrip(false);
        return;
      }
      this.displayingOn = 'trip';
      setTimeout(() => {
        this.enterTrip(tripIndex);
      }, 200);
      return;
    }
    this.backToTripList();

    if (!this.trips || !this.trips.length) {
      this.trips = [];
      this.isShowFilter && this.toggleFilter(true);
      this.displayingOn = 'trip';
      this.showingCount = null;
      setTimeout(() => {
        this.cardWrap.nativeElement.style.height = 'auto';
        if (!this.trips.length) {
          this.parent.isShowDirectionMap = false;
        }
      });
      return;
    }

    if (this.isEventEnabled) {
      this.getEventsFromCache().subscribe((events) => {
        this.trips = this.setDetaultImages(this.trips);
        this.afterSetDefaultImages();
      });
    } else {
      this.afterSetDefaultImages();
    }
  }

  private addGotoUserTripCount() {
    this.analytics = new HubAnalytics();
    this.analytics.tripPlanner.userTripClickCount = 1;
    if (config.isAnalyticsOn) {
      this.visitorApiService.updateTripPlanerAnalytics(this.hubName, this.analytics).subscribe();
    }
  }

  private afterSetDefaultImages() {
    this.isShowFilter && this.toggleFilter(true);
    this.displayingOn = 'trip';
    this.showingCount = null;
    if (!this.isMobile) {
      setTimeout(() => {
        this.cardWrap.nativeElement.style.maxHeight = this.cardContainerMaxHeightForTrip;
        this.cardWrap.nativeElement.style.height = 'auto';
      }, 100);

      if (this.trips && this.trips.length) {
        this.trips[0].isEventImageProcessed = true;
        this.parent.showDirectionMap(this.trips[0]);
        setTimeout(() => {
          this.parent.direction.showBanner();
        }, 200);
      } else {
        this.backToWelcomePage();
      }
    }
    //this.getTripCount();
    this.scrollToTop();
  }

  private backToWelcomePage() {
    this.parent.isShowDirectionMap = false;
    this.parent.isShowNormalMap = false;
    this.parent.isShowTour = false;
  }

  private setPaggination(data) {
    if (this.setNoItemPagination(data)) {
      return;
    }
    this.paginationIndex = 0;
    if (data.length > this.paginationPageLimit) {
      let max = this.paginationPageLimit * (this.paginationIndex + 1);
      max = max < this.allEventsOrPlaces.length ? max : this.allEventsOrPlaces.length;
      this.displayingOn === 'event' ? (this.events = data.slice(0, max)) : (this.places = data.slice(0, max));
      this.showingCount = `${this.paginationPageLimit * this.paginationIndex + 1} - ${max}`;
      this.noMoreNext = false;
      this.noMoreBack = true;
    } else {
      this.displayingOn === 'event' ? (this.events = data) : (this.places = data);
      this.showingCount = null;
    }
    this.processMultiColumnsItems();
  }

  private setNoItemPagination(data) {
    if (!data || !data.length) {
      this.noMoreNext = true;
      this.noMoreBack = true;
      this.showingCount = null;
      if (this.displayingOn === 'event') {
        this.events = [];
        this.eventRows = [];
      } else if (this.displayingOn === 'place') {
        this.places = [];
        this.placeRows = [];
      }
      this.cardWrap.nativeElement.style.height = 'auto';
      return true;
    }
  }

  private setFacebookUserID() {
    if (this.isUserloggedIn) {
      this.userFacebookID = SocialLoginPopupComponent.userId;
    } else {
      this.userFacebookID = null;
    }
  }

  private setEventDateRange(from, to) {
    if (from && !to) {
      this.filterDateRangeText = ` (after ${EventTimeService.toShortDateFormat(from)})`;
    } else if (!from && to) {
      this.filterDateRangeText = ` (before ${EventTimeService.toShortDateFormat(to)})`;
    } else if (from && to) {
      this.filterDateRangeText = ` (${EventTimeService.toShortDateFormat(from)} - ${EventTimeService.toShortDateFormat(
        to
      )})`;
    }
  }

  private afterGotTours(data: any, tourId?: string) {
    if (this.parent.featuresToggle.multipleCities) {
      if (!this.parent.isForTourList && this.parent.currentRegion && this.parent.currentRegion.tours) {
        data = data.filter((x) => this.parent.currentRegion.tours.any((y) => x._id === y.id));
      }
    }
    this.tours = data;
    this.isShowFilter && this.toggleFilter(true);
    this.displayingOn = 'tour';
    this.parent.isShowNormalMap = false;
    this.parent.isShowDirectionMap = false;
    this.currentTour = null;
    this.showingCount = null;
    if (!this.isMobile) {
      this.cardContainer.nativeElement.style.maxHeight = this.cardContainerFullHeight;
      // this.cardWrap.nativeElement.style.height = this.cardContainerFullHeight;
      this.cardWrap.nativeElement.style.maxHeight = 'none';
    } else {
      this.tourSpinner = [];
      this.tours.forEach((x) => {
        this.tourSpinner.push(false);
      });
    }
    this.scrollToTop();

    if (tourId) {
      this.parent.setPDFLoadingTip([8, 9, 10, 11]);
      let tour = this.tours.filter((x) => x._id === tourId).first();
      if (tour) {
        setTimeout(() => {
          this.parent.showTourDetail(tour);
          this.hideMask();
        });
      } else {
        alert('This a wrong itinerary id, please check!');
        this.switchToTours();
      }
    } else {
      this.showTourWaterfall.emit(this.tours);
      this.hideMask();
    }

    this.analytics = new HubAnalytics();
    this.analytics.tripPlanner.tourClickCount = 1;
    if (config.isAnalyticsOn) {
      this.visitorApiService.updateTripPlanerAnalytics(this.hubName, this.analytics).subscribe();
    }
  }

  private fitBounds() {
    this.googleMapService.getGoogle().then(() => {
      this.latLngBounds = new google.maps.LatLngBounds();
      let target = null;

      if (this.displayingOn === 'event') {
        target = this.events;
      } else if (this.displayingOn === 'place') {
        target = this.places;
      }
      target.forEach((x) => {
        if (!isNullOrUndefined(x.address.lat) && !isNullOrUndefined(x.address.lng)) {
          this.latLngBounds.extend(new google.maps.LatLng(x.address.lat, x.address.lng));
        }
      });
    });
  }

  private hideMapMobileTrigger($event) {
    // if (this.mobileMapTrigger) {
    //     this.mobileMapTrigger.nativeElement.style.display = 'none';
    // }
    if (this.isMobile) {
      this.showTripDetailModalForMobile(
        $event.item,
        $event.item.startTime ? 'event' : 'place',
        this.displayingOn === 'tour'
      );
    }
  }

  public showMask() {
    this.isSwitching = true;
  }

  public hideMask() {
    setTimeout(() => {
      this.isSwitching = false;
    }, 500);
  }

  private takeSettingsAndProcess() {
    this.allFrontendSettingsStore.allFrontendSettingsCommand
      .takeUntil(this.isDestroyed)
      .subscribe((command: AllFrontendSettingsCommand) => {
        if (command.toggle) {
          this.featuresToggle = command.toggle;
          if (this.isAllPlaceCategoriesTurnedOff) {
            this.featuresToggle.placeCalendar = false;
          }
          for (let category in this.filter.place) {
            if (this.featuresToggle.placeCategory[category]) {
              this.category.place = this.filter.place[category].key;
              this.filter.place[category].value = true;
              break;
            }
          }
        }
        if (command.customSettings) {
          this.logoUrl =
            isNullOrUndefined(command.customSettings.logo) ||
            isNullOrUndefined(command.customSettings.logo.isDefault) ||
            command.customSettings.logo.isDefault
              ? null
              : command.customSettings.logo.url;
          this.logo = command.customSettings.logo;
          if (command.customSettings.tourSidebarImage) {
            if (command.customSettings.tourSidebarImage.isDefault) {
              this.tourSideImg = this.imageService.imageSourceUrl(this.tourSideImg);
            } else {
              this.tourSideImg = this.imageService.imageSourceUrl(command.customSettings.tourSidebarImage.url);
            }
          }
          this.detailsStyle = command.customSettings.tripPlannerDetailsStyle;
          this.customDefaultPlaceCategory = command.customSettings.customDefaultPlaceCategory;
          console.log('customDefaultPlaceCategory ni trip', this.customDefaultPlaceCategory);
        }
        this.dataSource = command.dataSource || this.dataSource;
        this.style = command.style ? (command.style as StyleModel) : this.style;

        setTimeout(() => {
          if (!this.isMobile) {
            if (!this.parent.isForTourList && !this.parent.urlTripID && !this.parent.urlTourID) {
              setTimeout(() => {
                if (this.featuresToggle.multipleCities) {
                  // setTimeout(() => {
                  //     this.switchToTours();
                  // }, 300);
                  // return;
                  return;
                }
                if (this.isPlaceEnabled) {
                  this.switchToPlaces(true);
                } else if (this.isEventEnabled) {
                  this.switchToEvents(true);
                } else {
                  this.switchToTours();
                }
              });
            }
          } else {
            if (this.featuresToggle.multipleCities) {
              this.parent.isShowSidebarOnMobile = true;
              setTimeout(() => {
                this.switchToTours();
              }, 300);
              return;
            }
            this.setEventDateRange(this.parent.from, this.parent.to);
            this.fromForMobile = this.parent.from;
            this.toForMobile = this.parent.to;
          }
        });
      });
  }

  private listenShowOnMap() {
    this.visitorTripStore.tripCommand.takeUntil(this.isDestroyed).subscribe((item) => {
      if (!this.isMobile || isNullOrUndefined(item.item)) {
        return;
      }
      if (!isNullOrUndefined(item.item)) {
        let items = [];
        items = this.displayingOn === 'event' ? this.events : this.displayingOn === 'place' ? this.places : [];
        let targetIndex = 0;
        items.forEach((x, index) => {
          if (x._id === item.item._id) {
            targetIndex = index;
            return;
          }
        });
        let obj = {
          items: items,
          index: targetIndex,
        };
        this.parent.showOnMap(obj);
      }
    });
  }
}

export class HubAnalytics {
  public tripPlanner: {
    eventClickCount: number;
    placeClickCount: number;
    tourClickCount: number;
    userTripClickCount: number;
    shareClickCount: number;
  };

  constructor() {
    this.tripPlanner = {
      eventClickCount: 0,
      placeClickCount: 0,
      tourClickCount: 0,
      userTripClickCount: 0,
      shareClickCount: 0,
    };
  }
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/visitor/trip/trip.side.bar/visitor.trip.side.bar.component.ts